import React from "react";
import { render } from "react-dom";
import Root from "./Root";
import "./global.css";

document.addEventListener("DOMContentLoaded", () =>
  render(
    <Root />
    ,
    document.getElementById("root")
  )
);
